let host1 =
  window.location.hostname === 'timesheets-uat.msrcosmos.com'
    ? 'UAT'
    : window.location.hostname === 'timesheets.msrcosmos.com'
    ? 'Production'
    : 'UAT'
let BASE

if (host1 == 'UAT') {
  BASE = 'https://tsagent-uat.msrcosmos.com/api/v1'
} else if (host1 == 'Production') {
  BASE = 'https://tsagent.msrcosmos.com/api/v1'
}

export async function fetchContext(token) {
  const res = await fetch(`${BASE}/auth/context`, {
    method: 'POST',
    headers: {Authorization: `Bearer ${token}`},
  })
  if (!res.ok) throw new Error('Auth failed')
  return res.json()
}

export async function chatSync({sessionId, query, allowedBus, userContext}) {
  const res = await fetch(`${BASE}/chat/sync`, {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({
      session_id: sessionId,
      query,
      allowed_bus: allowedBus,
      user_context: userContext,
    }),
  })
  if (!res.ok) throw new Error('Chat request failed')
  return res.json()
}

export async function* chatStream({sessionId, query, allowedBus, userContext, history = []}) {
  const res = await fetch(`${BASE}/chat`, {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({
      session_id: sessionId,
      query,
      allowed_bus: allowedBus,
      user_context: userContext,
      history: history,
    }),
  })

  const reader = res.body.getReader()
  const decoder = new TextDecoder()
  let buffer = ''

  while (true) {
    const {done, value} = await reader.read()
    if (done) break
    buffer += decoder.decode(value, {stream: true})
    const lines = buffer.split('\n\n')
    buffer = lines.pop()
    for (const line of lines) {
      if (line.startsWith('data: ')) {
        try {
          yield JSON.parse(line.slice(6))
        } catch {}
      }
    }
  }
}

export async function fetchSessions(token) {
  const res = await fetch(`${BASE}/sessions`, {
    headers: {Authorization: `Bearer ${token}`},
  })
  if (!res.ok) throw new Error('Failed to fetch sessions')
  return res.json()
}

export async function fetchSessionMessages(sessionId, token) {
  const res = await fetch(`${BASE}/sessions/${sessionId}`, {
    headers: {Authorization: `Bearer ${token}`},
  })
  if (!res.ok) throw new Error('Failed to fetch session')
  return res.json()
}

export async function submitFeedback({sessionId, query, sql, vdbScore, rating, userId, orgId}) {
  const res = await fetch(`${BASE}/feedback`, {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({
      session_id: sessionId,
      query,
      sql,
      vdb_score: vdbScore,
      rating,
      user_id: userId,
      org_id: orgId,
    }),
  })
  if (!res.ok) throw new Error('Feedback failed')
  return res.json()
}

export async function downloadExcel(sessionId) {
  const res = await fetch(`${BASE}/download/${sessionId}`)
  if (!res.ok) throw new Error('Download failed')

  const blob = await res.blob()
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = `export_${sessionId.slice(0, 8)}.xlsx`
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(url)
}

export function renameSession(token, sessionId, title) {
  return fetch(`${BASE}/sessions/${sessionId}`, {
    method: 'PATCH',
    headers: {'Content-Type': 'application/json', Authorization: `Bearer ${token}`},
    body: JSON.stringify({title}),
  }).then((r) => {
    if (!r.ok) throw new Error('Rename failed')
    return r.json()
  })
}

export function deleteSession(token, sessionId) {
  return fetch(`${BASE}/sessions/${sessionId}`, {
    method: 'DELETE',
    headers: {Authorization: `Bearer ${token}`},
  }).then((r) => {
    if (!r.ok) throw new Error('Delete failed')
    return r.json()
  })
}
